/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import * as Styled from "./styles";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
} from "@mui/material";
import { useAuth } from "shared/providers/auth";

import { ReactComponent as CalendarIcon } from "shared/assets/svg/calendar.svg";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { formatDateLabelFromYMD, getCurrentLocalDateYMD } from "shared/utils/date";

import { SlRefresh } from "react-icons/sl";

const FilterList: React.FC = () => {
  const {
    schedules,
    user,
    timeChoosen,
    setTimeChoosen,
    timeSelect,
    setTimeSelect,
    showServed,
    setShowServed,
    controlArrived,
    setControlArrived,
    timeRefresh,
    isWebSocketConnected,
  } = useAuth();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [isRotating, setIsRotating] = React.useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const formattedDate = formatDateLabelFromYMD(getCurrentLocalDateYMD());

  function formatDate(dateStr: string) {
    const [daySc, month, yearSc] = dateStr.split("/");
    const dateSc = `${yearSc}-${month}-${daySc}`;

    setTimeSelect(formatDateLabelFromYMD(dateSc));
    setTimeChoosen(dateSc);
    schedules({ id: user.data.id, date: dateSc });
  }

  const refresh = React.useCallback(() => {
    const selectedDate = timeChoosen || getCurrentLocalDateYMD();

    schedules({
      id: user && user.data && user.data.id ? user.data.id : "0",
      date: selectedDate,
    });

    setIsRotating(true);
    setTimeout(() => setIsRotating(false), 1000);
  }, [schedules, timeChoosen, user]);

  React.useEffect(() => {
    refresh();
  }, []);

  React.useEffect(() => {
    // Se WebSocket conectado, não precisa de polling - as atualizações vêm em tempo real
    if (isWebSocketConnected) {
      console.log('[FilterList] WebSocket conectado - polling desabilitado');
      return;
    }

    console.log('[FilterList] WebSocket desconectado - usando polling a cada', timeRefresh, 'ms');
    const intervalId = setInterval(() => {
      refresh();
    }, timeRefresh);

    return () => clearInterval(intervalId);
  }, [refresh, isWebSocketConnected, timeRefresh]);

  return (
    <>
      <Styled.Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Styled.CalendarBox>
            <button
              onClick={handleClick}
              style={{
                backgroundColor: "transparent",
                border: "none",
                display: "flex",
                flexDirection: "row",
                gap: "5px",
              }}
            >
              <CalendarIcon width="25px" height="25px" />
              <p>{timeSelect.length > 1 ? timeSelect : formattedDate}</p>
            </button>
          </Styled.CalendarBox>

          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <FormGroup className="hiddenMobile">
              <FormControlLabel
                sx={{ flexDirection: "row-reverse" }}
                control={<Checkbox defaultChecked />}
                label="Mostrar Atendidos"
                onClick={() => setShowServed(!showServed)}
              />
            </FormGroup>
            <Button onClick={refresh}>
              <SlRefresh size={28} className={isRotating ? "rotate" : ""} />
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            margin: "15px 0",
          }}
        >
          <Button
            variant={controlArrived === "ARRIVED" ? "contained" : "outlined"}
            onClick={() => setControlArrived("ARRIVED")}
          >
            Controle de Chegada
          </Button>
          <Button
            variant={controlArrived === "SCHEDULE" ? "contained" : "outlined"}
            onClick={() => setControlArrived("SCHEDULE")}
          >
            Agendamentos
          </Button>
        </Box>
      </Styled.Content>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
          <DateCalendar
            onChange={(item) => {
              handleClose();
              formatDate(dayjs(item).format("DD/MM/YYYY"));
            }}
          />
        </LocalizationProvider>
      </Menu>
    </>
  );
};

export { FilterList };
